export const BOT_USER_ID = 1003;
export const ORDER_SERVICE_ID = 1005;

export const SPECIAL_SERVICE_IDS = [31, 1001, 1002, 1003, 1004, 1005];
export const MESSAGABLE_SERVICE_IDS = [31, 1003];
export const READ_ONLY_SERVICE_IDS = [1001, 1002, 1004, 1005];

export const isServiceUserId = (id) => id != null && SPECIAL_SERVICE_IDS.includes(Number(id));

export const ORDER_ID_REGEX = /\[order_id:(\d+)\]/;
export const IMAGE_EXTENSIONS = /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif|tiff|tif)$/i;
export const ANNOUNCEMENT_BASE_URL = 'https://agroland.kz/announcement/';
export const ANNOUNCEMENT_URL_REGEX = /^https:\/\/agroland\.kz\/announcement\/[^/]+$/;

export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const MAX_RECORDING_SECONDS = 120;
export const SUPPORT_OPERATOR_ID = 31;
